export const wrapFunctionToProp = (functionToWrap: () => number) => {
  const obj = { value: functionToWrap() }
  let animationFrame: number | null = null
  const update = () => {
    obj.value = functionToWrap()
    animationFrame = requestAnimationFrame(update)
  }
  update()
  const destroy = () => {
    if (animationFrame) cancelAnimationFrame(animationFrame)
  }
  return {
    obj,
    destroy,
  }
}
